module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-MediumItalic-d88295b48aa872d6ba40d6444ccc1c16.woff2";